import React, { useState, useEffect, useRef } from 'react';
import { Sun, Moon, Map, Navigation, Layers, Database, Settings, Activity } from 'lucide-react';
import { motion } from 'framer-motion';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  useTheme,
  ThemeProvider,
  createTheme,
  Grid,
  Tooltip
} from '@mui/material';
// import author_supervision from '../icons/author_supervision.png'
import author_supervision from '../assets/icons/Tile_Author_Supervision.png'
import accountings from '../assets/icons/Tile_Accountings.png'
import tasks from '../assets/icons/Tile_Tasks.png'
import logoKomoks from '../assets/icons/Logo_Komoks.png'
// import objects from '../assets/icons/Tile_Objects.png' // Предполагается, что иконка существует
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDarkMode } from '../store/reducers/stateReducer';
import { APP_UPDATE_TIME, APP_VERSION } from '../constants/version';
const cards = [
  {
    title: "ЗАДАЧИ",
    image: tasks,
    icon: Map,
    route: '/tasks'
  },
  // {
  //   title: "РЕЕСТР ОБЪЕКТОВ",
  //   description: `📋 Просмотр и управление объектами строительства.`,
  //   image: tasks, // Используйте подходящую иконку
  //   icon: Database,
  //   route: '/objects_reestr'
  // },
  {
    title: "ГЕОГРАФИЯ ОБЪЕКТОВ",
    image: author_supervision,
    icon: Map,
    route: '/an'
  },
  {
    title: "ПРЕДПИСАНИЯ АВТОРСКОГО НАДЗОРА",
    image: accountings,
    icon: Database,
    route: '/accountings'
  }
];

const CustomCard = ({ title, description, image, isDark, onClick, route }) => {
  const [fontSize, setFontSize] = useState(16);
  const titleRef = useRef(null);
  const isMobile = window.innerWidth <= 768;

  // useEffect(() => {
  //   const adjustFontSize = () => {
  //     if (titleRef.current) {
  //       const element = titleRef.current;
  //       const cardElement = element.closest('.MuiCard-root');
  //       if (!cardElement) return;

  //       // Получаем размеры карточки для расчета доступного пространства
  //       const cardRect = cardElement.getBoundingClientRect();
  //       const containerHeight = cardRect.height * 0.25; // 25% от высоты карточки для текста
  //       const containerWidth = cardRect.width - 16; // Ширина минус padding

  //       let currentSize = isMobile ? 12 : 16;

  //       // Устанавливаем начальный размер шрифта
  //       element.style.fontSize = `${currentSize}px`;
  //       element.style.lineHeight = '1.2';

  //       // Уменьшаем шрифт пока текст не поместится по высоте
  //       while (element.scrollHeight > containerHeight && currentSize > 8) {
  //         currentSize -= 0.5;
  //         element.style.fontSize = `${currentSize}px`;
  //       }

  //       // Дополнительная проверка по ширине с учетом padding
  //       while (element.scrollWidth > containerWidth && currentSize > 8) {
  //         currentSize -= 0.5;
  //         element.style.fontSize = `${currentSize}px`;
  //       }

  //       setFontSize(currentSize);
  //     }
  //   };

  //   // Задержка для корректного расчета размеров после рендера
  //   const timeoutId = setTimeout(adjustFontSize, 100);

  //   window.addEventListener('resize', adjustFontSize);
  //   return () => {
  //     clearTimeout(timeoutId);
  //     window.removeEventListener('resize', adjustFontSize);
  //   };
  // }, [title, isMobile]);

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
      onClick={() => onClick(route)}
      style={{
        cursor: 'pointer',
        width: '100%',
        height: '100%'
      }}
    >
      <Card
        className="MuiCard-root"
        sx={{
          aspectRatio: '3/2', // Фиксированное соотношение сторон 3:4
          display: 'flex',
          flexDirection: 'column',
          bgcolor: isDark ? 'grey.800' : 'background.paper',
          borderRadius: 2,
          boxShadow: isDark ?
            '0 4px 20px rgba(79, 195, 247, 0.1)' :
            '0 4px 20px rgba(41, 182, 246, 0.1)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            boxShadow: isDark ?
              '0 8px 30px rgba(79, 195, 247, 0.2)' :
              '0 8px 30px rgba(41, 182, 246, 0.2)',
            transform: 'translateY(-2px)'
          }
        }}
      >
        <CardMedia
          component="img"
          sx={{
            height: '80%', // Изображение занимает 70% высоты карточки
            objectFit: 'cover',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'scale(1.05)'
            }
          }}
          image={image}
          alt={title}
        />
        <CardContent
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: 0,
            height: '20%', // Занимает оставшиеся 30% высоты карточки
            overflow: 'hidden',
            '&:last-child': {
              paddingBottom: 0
            }
          }}
        >
          <Typography
            ref={titleRef}
            variant="h6"
            component="div"
            color={isDark ? 'grey.100' : 'text.primary'}
            align="center"
            sx={{
              fontWeight: 600,
              // fontSize: `${fontSize}px`,
              fontSize: { xs: '12px', sm: '14px', md: '16px', lg: '18px' },
              lineHeight: 1.2,
              wordBreak: 'break-word',
              hyphens: 'auto',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {title}
          </Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
};

const NeuralBackground = ({ isDark }) => {
  const canvasRef = useRef(null);
  const mouseRef = useRef({ x: -100, y: -100 });
  const nodesRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Initialize nodes
    const nodes = [];
    const isMobile = window.innerWidth <= 768;
    for (let i = 0; i < (isMobile ? 30 : 120); i++) {
      nodes.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: Math.random() * 2 - 1,
        vy: Math.random() * 2 - 1
      });
    }
    nodesRef.current = nodes;

    const animate = () => {
      if (!ctx || !canvas) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = isDark ? '#000000' : '#e6ede6';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Update and draw nodes
      for (let node of nodes) {
        let dx = mouseRef.current.x - node.x;
        let dy = mouseRef.current.y - node.y;
        let distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < 150) {
          node.vx += dx * 0.005;
          node.vy += dy * 0.005;
        }

        node.x += node.vx;
        node.y += node.vy;

        node.vx += (Math.random() - 0.5) * 0.1;
        node.vy += (Math.random() - 0.5) * 0.1;

        node.vx *= 0.98;
        node.vy *= 0.98;

        if (node.x < 0 || node.x > canvas.width) node.vx *= -1;
        if (node.y < 0 || node.y > canvas.height) node.vy *= -1;

        // Красивый голубой цвет для вершин
        ctx.fillStyle = isDark ? '#4FC3F7' : '#29B6F6'; // Светло-голубой для темного режима, голубой для светлого
        ctx.beginPath();
        ctx.arc(node.x, node.y, 3, 0, Math.PI * 2);
        ctx.fill();
      }

      // Draw connections
      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          let dx = nodes[i].x - nodes[j].x;
          let dy = nodes[i].y - nodes[j].y;
          let distance = Math.sqrt(dx * dx + dy * dy);
          if (distance < 150) {
            // Красивый темно-синий цвет для ребер
            ctx.strokeStyle = isDark ?
              `rgba(25, 118, 210, ${1 - distance / 150})` : // Темно-синий для темного режима
              `rgba(13, 71, 161, ${1 - distance / 150})`; // Более темно-синий для светлого режима
            ctx.beginPath();
            ctx.moveTo(nodes[i].x, nodes[i].y);
            ctx.lineTo(nodes[j].x, nodes[j].y);
            ctx.stroke();
          }
        }
      }

      requestAnimationFrame(animate);
    };

    animate();

    const handleMouseMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDark]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        pointerEvents: 'none'
      }}
    />
  );
};

function StartPage() {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const user = useSelector(state => state.state.user)
  const darkMode = useSelector(state => state.state.darkMode)

  // Установка заголовка для стартовой страницы
  useEffect(() => {
    document.title = "Ситуация в КОМОКС";
  }, []);

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleToggleDarkMode = () => {
    dispatch(toggleDarkMode());
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          position: 'relative',
          bgcolor: darkMode ? 'grey.900' : 'grey.50',
          zIndex: 10000,
          px: { xs: 1, sm: 2 }
        }}
      >
        <NeuralBackground isDark={darkMode} />

        <IconButton
          onClick={handleToggleDarkMode}
          sx={{
            position: 'fixed',
            top: 16,
            right: 16,
            zIndex: 1,
            bgcolor: darkMode ? 'grey.800' : 'background.paper',
            color: darkMode ? 'white' : 'text.primary',
            '&:hover': {
              bgcolor: darkMode ? 'grey.600' : 'grey.100',
            },
          }}
        >
          {darkMode ? <Sun size={24} /> : <Moon size={24} />}
        </IconButton>

        {/* Версия приложения в левом нижнем углу */}
        <Tooltip
          title={APP_UPDATE_TIME}
          placement='top'
          arrow
          slotProps={
            {
              popper: {
                sx: {
                  zIndex: 99999
                }
              }
            }
          }>
          <Box
            sx={{
              position: 'fixed',
              bottom: 16,
              left: 16,
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              borderRadius: 2,
              px: 2,
              py: 1,
              backdropFilter: 'blur(5px)',
              pointerEvents: 'auto'
            }}
          >

            <Typography
              variant="body1"
              color={darkMode ? 'grey.100' : 'text.primary'}
              sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, fontWeight: 500 }}
            >
              v{APP_VERSION}
            </Typography>


          </Box>
        </Tooltip>
        {/* Ситуация в КОМОКС в правом нижнем углу */}
        <Box
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            // bgcolor: isDark ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.9)',
            borderRadius: 2,
            px: 2,
            py: 1,
            backdropFilter: 'blur(5px)',
            // border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.1)'
          }}
        >
          <Typography
            variant="body1"
            color={darkMode ? 'grey.100' : 'text.primary'}
            sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, fontWeight: 500 }}
          >
            Ситуация в КОМОКС
          </Typography>
          <Box sx={{
            width: { xs: '26px', md: '32px' },
            height: { xs: '26px', md: '32px' },
          }}>
            <img
              src={logoKomoks}
              alt="КОМОКС"
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>

        </Box>

        <Box sx={{ py: { xs: 4, sm: 8 }, px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }}
            sx={{
              minHeight: { xs: '70vh', sm: '80vh' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}
          >
            {cards.map((card, index) => {
              if (user.roles.includes('viewer') && card.route === '/tasks') return null
              return <Grid
                item
                key={index}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  maxWidth: { xs: '250px', sm: '300px', md: '350px', lg: '400px' },
                  width: '100%'
                }}
              >
                <CustomCard
                  title={card.title}
                  description={card.description}
                  image={card.image}
                  isDark={darkMode}
                  onClick={handleCardClick}
                  route={card.route}
                />
              </Grid>
            }).filter(Boolean)}
          </Grid>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default StartPage;